import { useTheme } from 'next-themes';
import { Toaster as Sonner } from 'sonner';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="group toaster $tw-z-[1500] $tw-mr-16"
      toastOptions={{
        classNames: {
          toast:
            '$tw-bg-background $tw-text-foreground $tw-border-border $tw-shadow-lg $tw-p-4 $tw-text-sm',
          description: '$tw-text-muted',
          actionButton: '$tw-bg-primary $tw-text-primary-foreground',
          cancelButton: '$tw-bg-muted $tw-text-muted-foreground',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
